import React, { Component } from 'react'
import { FormikInputField } from './InputField'

export const FormikTextareaField = ({ ...props }) => {

    return <FormikInputField multiline={true} {...props} />
    
}
